import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Faqs from './components/Faqs';
import RelatedLinks from './components/RelatedLinks';
import relatedLinkPropTypes from './components/RelatedLinks/RelatedLink/propTypes';
import translations from './translations.en.json';
import '@fiverr/i18n/singleton';
import './index.scss';
import _ from 'lodash';

class SeoSubCategory extends PureComponent {

    constructor(props) {
        super(props);
        i18n.add(translations);
    }

    render() {

        const {
            title,
            faqs,
            relatedLinks
        } = this.props;

        if (_.isEmpty(faqs) && _.isEmpty(relatedLinks)) {
            return null;
        }

        return (

            <div className="seo-sub-category">
                {!_.isEmpty(faqs) && <Faqs title={title} faqs={faqs}/>}
                {!_.isEmpty(relatedLinks) && <RelatedLinks title={title} relatedLinks={relatedLinks}/>}
            </div>
        );
    }
}

SeoSubCategory.propTypes = {
    title: PropTypes.string,
    faqs: PropTypes.array,
    relatedLinks: PropTypes.arrayOf(
        PropTypes.shape(relatedLinkPropTypes)
    )
};

SeoSubCategory.defaultProps = {
    title: '',
    faqs: [],
    relatedLinks: []
};

export default SeoSubCategory;



// WEBPACK FOOTER //
// ./src/SeoSubCategory.js